import { Card } from '@mui/material';
import React from 'react';
import Courses from '../Courses/Courses';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Home from '../Home/Home';

const AllCourses = () => {
    return (
        <div>
            <div>
                <h1>Our All Courses Are Here !!</h1>
                <h3>Choose your Courses</h3>
            </div>
            <Home></Home>
        </div>
    );
};

export default AllCourses;